import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import FileUpload from '@narvar/nth-block-file-upload';
import SidebarSectionTitle from '../SidebarSectionTitle/SidebarSectionTitle';
import { PHOTO_UPLOAD_FILE_EXTS } from '../../constants/photoUpload';
import { deleteImage } from '../../actions/photoUpload';
import { ImageThumbnail, SpinnerThumbnail } from './Thumbnail';

const StyledThumbnailContainer = styled.div`
  margin-top: 1.5rem;
  margin-bottom: 1.5rem;
  display: flex;
`;

const StyledErrorMsg = styled.p`
  color: #d40511;
  text-align: left;
`;

const mapStateToProps = ({ photoUpload: { isUploading, errorMsg, images } }) => ({
  isUploading,
  errorMsg,
  images,
});

export const PhotoUploader = ({
  dispatch,
  title,
  placeholder,
  images,
  isUploading,
  onDrop,
  errorMsg,
}) => (
  <div className="photo-upload__container">
    <SidebarSectionTitle title={title} />
    <StyledErrorMsg
      className="photo-upload__error-msg"
      dangerouslySetInnerHTML={{
        __html: errorMsg,
      }}
    />
    <FileUpload multiple onDrop={onDrop} accept={PHOTO_UPLOAD_FILE_EXTS} disabled={isUploading}>
      <div dangerouslySetInnerHTML={{ __html: placeholder }} />
    </FileUpload>
    {(images.length > 0 || isUploading) && (
      <StyledThumbnailContainer className="photo-upload__thumbnail-container">
        {images.map(({ path, filename }) => (
          <ImageThumbnail
            key={filename}
            src={`${path}${filename}`}
            filename={filename}
            onDelete={() => dispatch(deleteImage(filename))}
          />
        ))}
        {isUploading && <SpinnerThumbnail />}
      </StyledThumbnailContainer>
    )}
  </div>
);

PhotoUploader.defaultProps = {
  errorMsg: '',
  images: [],
  placeholder: '',
  title: '',
};

PhotoUploader.propTypes = {
  dispatch: PropTypes.func.isRequired,
  errorMsg: PropTypes.string,
  images: PropTypes.arrayOf(
    PropTypes.shape({
      path: PropTypes.string.isRequired,
      filename: PropTypes.string.isRequired,
    }).isRequired,
  ),
  isUploading: PropTypes.bool.isRequired,
  onDrop: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  title: PropTypes.string,
};

export default connect(mapStateToProps)(PhotoUploader);
